"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoFileSource = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropTypes = require("./PropTypes");
var _hooks = require("../../hooks");
var _useVideoJSPlayer = require("../../hooks/useVideoJSPlayer");
var _feature = require("@studio/feature.flags");
var _useVideoJSMetrics = require("../../hooks/useVideoJSMetrics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VideoFileSource = exports.VideoFileSource = function VideoFileSource(_ref) {
  var source = _ref.source,
    autoPlay = _ref.autoPlay,
    showControls = _ref.showControls,
    onTogglePlayback = _ref.onTogglePlayback,
    mediaPlayer = _ref.mediaPlayer,
    serverTime = _ref.serverTime,
    serverTimeDelta = _ref.serverTimeDelta;
  var isVideoJsPlayer = (0, _feature.shouldHaveFeature)('studio.videoJsPlayer');
  var _React$useState = _react["default"].useState(true),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var videoRef = (0, _react.useRef)();
  var isObjectSourceValue = (0, _typeof2["default"])(source.value) === 'object';
  var settings = isObjectSourceValue ? source.value : mediaPlayer;
  var videoUrl = isObjectSourceValue ? source.value.url : source.value;
  var playerRef = (0, _useVideoJSPlayer.useVideoJSPlayer)(source._id, videoUrl, settings, serverTime, serverTimeDelta);
  (0, _useVideoJSMetrics.useVideoJSMetrics)(source, playerRef);
  var style = !isVideoJsPlayer && loading ? {
    width: '100%',
    opacity: 0,
    transition: 'opacity 3s ease-in-out'
  } : {};
  (0, _hooks.usePlayableElement)(videoRef, settings, serverTime, serverTimeDelta, source._id);
  var handlePlay = onTogglePlayback.bind(null, 'play');
  var handlePause = onTogglePlayback.bind(null, 'pause');
  (0, _react.useEffect)(function () {
    if (!isVideoJsPlayer && videoRef.current) {
      var element = videoRef.current;
      element.addEventListener('loadeddata', function () {
        return setLoading(false);
      });
      return function () {
        return element.removeEventListener('loadeddata', null);
      };
    }
  }, []);
  if (isVideoJsPlayer) {
    return _react["default"].createElement("video", {
      id: "media_player_".concat(source._id),
      "data-testid": "video_".concat(source._id),
      className: "video-js vjs-default-skin",
      style: {
        backgroundColor: 'transparent'
      }
    }, "Your browser does not support the video file");
  } else {
    return _react["default"].createElement("video", {
      ref: videoRef,
      src: videoUrl
      //TODO: remove this, it is @deprecated
      ,
      autoPlay: autoPlay,
      controls: showControls,
      disablePictureInPicture: true,
      onPlay: handlePlay,
      onPause: handlePause,
      id: "media_player_".concat(source._id),
      "data-testid": "video_".concat(source._id),
      style: style
    }, "Your browser does not support the video file");
  }
};
VideoFileSource.defaultProps = {
  showControls: false,
  //@deprecated in favor of source.value.isPlaying
  autoPlay: false,
  //@deprecated in favor of source.value object format
  mediaPlayer: {}
};
VideoFileSource.propTypes = {
  source: _PropTypes.Source,
  showControls: _propTypes["default"].bool,
  //@deprecated in favor of source.value.isPlaying
  autoPlay: _propTypes["default"].bool,
  onTogglePlayback: _propTypes["default"].func.isRequired,
  onVolumeChanged: _propTypes["default"].func,
  onSeekTimeChanged: _propTypes["default"].func,
  //@deprecated in favor of source.value object format
  mediaPlayer: _PropTypes.MediaPlayer,
  serverTime: _propTypes["default"].number,
  serverTimeDelta: _propTypes["default"].number
};